<template>
  <div>
    <button
      class="hover_op call_more"
      @click="show_drop = !show_drop"
      v-click-outside="hide"
    >
      <img src="@/assets/img/user_more_icon_black.svg" alt="" />
    </button>

    <div class="extras_drop drop" :class="{ active: show_drop }">
      <button @click="audioOff(participant), (show_drop = false)">Mute</button>

      <button @click="audioOn(participant), (show_drop = false)">Unmute</button>
      <button @click="kickParticipant(participant), (show_drop = false)">
        Kick
      </button>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";

export default {
  data() {
    return {
      show_drop: false,
    };
  },

  props: {
    id: String,
    participant: {},
  },

  methods: {
    muteParticipant(id) {
      this.$store.dispatch("muteParticipant", id);
    },

    unmuteParticipant(id) {
      this.$store.dispatch("unmuteParticipant", id);
    },

    eject(id) {
      this.$store.dispatch("eject", id);
    },

    hide() {
      this.show_drop = false;
    },

    audioOff(participant) {
      return this.$store.dispatch("participantAudio", {
        participant,
        enabled: false,
      });
    },
    videoOff(participant) {
      return this.$store.dispatch("participantVideo", {
        participant,
        enabled: false,
      });
    },
    audioOn(participant) {
      return this.$store.dispatch("participantAudio", {
        participant,
        enabled: true,
      });
    },
    videoOn(participant) {
      return this.$store.dispatch("participantVideo", {
        participant,
        enabled: true,
      });
    },
    kickParticipant(participant) {
      return this.$store.dispatch("kickParticipant", participant);
    },
  },

  mounted() {
    this.popupItem = this.$el;
  },

  directives: {
    ClickOutside,
  },
};
</script>

<style scoped lang="scss">
.extras_drop {
  z-index: 2;
  top: 30px;
  width: 358px;
  right: 5px;

  @media all and (max-width: 767px) {
    width: 256px;
    top: 55px;
    right: 12px;
  }
}
</style>
